export default __webpack_public_path__ + "static/media/yellow-landing.bd0c34d9.webp";